import styled from 'vue3-styled-components';

// 모달 오버레이
export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
`;

// 모달 컨테이너
export const ModalContainer = styled.div`
    background: white;
    border-radius: 12px;
    padding: 0;
    max-width: 600px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
`;

// 모달 헤더
export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;
`;

export const ModalTitle = styled.h3`
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #6b7280;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
        background: #f3f4f6;
        color: #1f2937;
    }
`;

// 모달 콘텐츠
export const ModalContent = styled.div`
    padding: 24px;
`;

// 추가 버튼
export const AddButton = styled.button`
    padding: 10px 20px;
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;

    &:hover {
        background: #1a6b7a;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(15, 76, 92, 0.3);
    }

    &:active {
        transform: translateY(0);
    }
`;

// 테이블
export const TypeTable = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const TableHeader = styled.thead`
    background: #f3f4f6;
`;

export const TableHeaderRow = styled.tr``;

export const TableHeaderCell = styled.th`
    padding: 12px;
    text-align: left;
    border: 1px solid #e5e7eb;
    font-weight: 600;
    color: #374151;
    font-size: 14px;

    &:last-child {
        text-align: center;
    }
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
    transition: background-color 0.2s ease;

    &:hover {
        background: #f9fafb;
    }
`;

export const TableCell = styled.td`
    padding: 12px;
    border: 1px solid #e5e7eb;
    color: #1f2937;
    font-size: 14px;

    &:last-child {
        text-align: center;
    }
`;

// 삭제 버튼
export const DeleteButton = styled.button`
    padding: 6px 12px;
    background: #dc2626;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
        background: #b91c1c;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
    }

    &:active {
        transform: translateY(0);
    }
`;

// 빈 상태 메시지
export const EmptyMessage = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #6b7280;
    font-size: 14px;
`;